# Ticket

A draft ticket for the team that owns the scraper, built from this run's
findings.

Nothing is posted automatically, and nothing is posted without confirmation.
What would be sent is shown in full first; only the title and description leave
this browser, and the attempt is recorded with a hash of what was sent rather
than the text itself.

The draft hedges on root cause by default. This tool sees two export files — it
can say a field went blank in every record, and cannot say why.
